import generateContext, { createAction } from '@shared/context';

export enum DeliveryMenuNavigationItem {
  CourierApp = 'COURIER_APP',
  Map = 'MAP',
  Orders = 'ORDERS',
}

interface IDeliveryNavigationState {
  selectedNavigationItem: DeliveryMenuNavigationItem;
}

enum DeliveryMenuNavigationActionType {
  SetActiveMenu = 'SET_ACTIVE_MENU',
  FlushMenu = 'FLUSH_MENU',
}

const initialState: IDeliveryNavigationState = {
  selectedNavigationItem: DeliveryMenuNavigationItem.CourierApp,
};

const reducer = (
  state: IDeliveryNavigationState,
  action: { type: DeliveryMenuNavigationActionType; payload?: any }
): IDeliveryNavigationState => {
  switch (action.type) {
    case DeliveryMenuNavigationActionType.SetActiveMenu:
      return {
        ...state,
        selectedNavigationItem: action.payload,
      };
    case DeliveryMenuNavigationActionType.FlushMenu:
      return {
        ...state,
        selectedNavigationItem: DeliveryMenuNavigationItem.CourierApp,
      };
    default:
      return state;
  }
};

const [
  DeliveryNavigationCtxProvider,
  useDeliveryNavigationState,
  useDeliveryNavigationDispatch,
] = generateContext(reducer, initialState);

const useDeliveryNavigationActions = () => {
  const dispatch = useDeliveryNavigationDispatch();

  const setActiveMenu = (menuItem: DeliveryMenuNavigationItem) => {
    const action = createAction(
      DeliveryMenuNavigationActionType.SetActiveMenu,
      menuItem
    );
    dispatch(action);
  };

  const flushMenu = () => {
    const action = createAction(DeliveryMenuNavigationActionType.FlushMenu);
    dispatch(action);
  };

  return {
    setActiveMenu,
    flushMenu,
  };
};

export {
  DeliveryNavigationCtxProvider,
  useDeliveryNavigationState,
  useDeliveryNavigationActions,
};
